import Repository from "./RepositoryFactoryMain";
const INSERT_SEOMETA = "insertMeta";
const GET_SEOMETA = "getMeta";

export default {
  insertSeoMeta(payload) {
    return Repository.post(transformRoute(INSERT_SEOMETA), payload);
  },
  getSeoMeta(payload) {
    return Repository.post(transformRoute(GET_SEOMETA), payload);
  },
};

const transformRoute = (route) => {
  return `/seo/${route}`;
};
